import React from 'react';
import IconButton from "@material-ui/core/IconButton";
import Typography from '@material-ui/core/Typography';
import BookmarkIcon from '@material-ui/icons/Bookmark';
import BookmarkBorderOutlinedIcon from '@material-ui/icons/BookmarkBorderOutlined';
import FavoriteIcon from '@material-ui/icons/Favorite';
import FavoriteBorderOutlinedIcon from '@material-ui/icons/FavoriteBorderOutlined';
import { db } from '../settings/firebase';
import { sendnotification } from '../function/sendnotification';

// いいねとセレクトボタン（ブックマークエリア）の表示
// data: <object>Firestoreからとった記事データ
// nowuid: <string>現在のユーザのUID
// changeStateMylike, changeStateMyselect: 状態を変更するときに実行する関数
// mylike, myselect: <bool>セレクトしているか
// star: <int>セレクトスターの数
// className: IconButtonのクラス
// iconSize: アイコンの大きさを指定
function BookmarkArea (props) {
  const { data, nowuid, changeStateMylike, changeStateMyselect, mylike, myselect, star, className, iconSize } = props;

  let likelen = 0;
  // console.log(data.like)
  if(data.like) {
    likelen = data.like.length;
    if (nowuid !== "") {
      for(let likeidx2 = 0; likeidx2 < likelen; likeidx2++) {
        if(data.like[likeidx2].uid === nowuid) {
          changeStateMylike(true);
          break;
        }
      }
    }
  }

  // いいねの登録・解除
  const changeLike = async() => {
    // ユーザ認証情報の取得
    if (nowuid !== "") {
      let like = data.like;
      let requireAdd = true;
      for(let likeidx = 0; likeidx < like.length; likeidx++) {
        if(like[likeidx].uid === nowuid) {
          requireAdd = false;
          like.splice(likeidx, 1);
          break;
        }
      }
      if(requireAdd) {
        like.push({
          uid: nowuid,
          ts: new Date(),
        });
      }
      console.log("CollectBookmark", requireAdd)
      await db.collection("items").doc(data.docId).update({
        like: like,
      }).then(async () => {
        console.log("Document successfully updated!" + like.length);
        changeStateMylike(requireAdd);
        if (requireAdd) {
          const userdoc = await db.collection("users").doc(nowuid).get();
          // いいねを相手に通知
          const likeobj = {title: data.title, id: data.docId};
          sendnotification(data.recommender, userdoc, "like", userdoc.data().name+"がいいねしました。", false, likeobj);
        }
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
    } else {
      window.location.href = "/signin?redirect=" + encodeURIComponent("/" + data.displayid + "/p/" + data.docId);
    }
  }

  // セレクトの登録・解除
  const changeSelect = async() => {
    // ユーザ認証情報の取得
    if (nowuid !== "") {
      let requireAdd = true;
      await db.collection("users").doc(nowuid).get().then(async doc => {
        if (doc.exists) {
          let idx = 0;
          let favs = doc.data().favorite;
          if (favs.length > 0) {
            await favs.forEach(async fav => {
              // console.log(fav)
              if (fav.pid === data.docId) {
                requireAdd = false;
                favs.splice(idx, 1);
                await db.collection("items").doc(data.docId).update({
                  star: star-1,
                })
                changeStateMyselect(false, star-1);  //状態変数の更新を呼び出す
              }
              idx += 1;
            })
          }
          if (requireAdd) {
            favs.push({
              pid: data.docId,
              ts: new Date(),
            });
            await db.collection("items").doc(data.docId).update({
              star: star+1,
            })
            changeStateMyselect(true, star+1);
          }
          await db.collection("users").doc(nowuid).update({
            favorite: favs,
          })
        }
      }).then(async () => {
        console.log("Document successfully updated!");
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
      });
    } else {
      window.location.href = "/signin?redirect=" + encodeURIComponent("/" + data.displayid + "/p/" + data.docId);
    }
  }

  return (
    <>
      <IconButton aria-label="like" onClick={changeLike} className={className}>
        {mylike?
          <FavoriteIcon style={{width: iconSize, height: iconSize, color: "#ff116b"}}/> 
        : <FavoriteBorderOutlinedIcon style={{width: iconSize, height: iconSize}} />
        }
      </IconButton>
      <Typography style={{marginRight: "5px"}}>{likelen}</Typography>
      <div>
        <IconButton
          className={className}
          onClick={changeSelect}
          aria-label="bookmark"
        >
          {myselect?
            <BookmarkIcon style={{width: iconSize, height: iconSize, color: "#e6cf7e"}} />
          : <BookmarkBorderOutlinedIcon style={{width: iconSize, height: iconSize}} />
          }
        </IconButton>
      </div>
      <Typography style={{marginRight: "5px"}}>{star}</Typography>
    </>
  )
}

export default BookmarkArea;